/**
 * Register the OneSignal service worker at site root (scope `/`), only when
 * nothing holds that scope yet. The OneSignal SDK registers the same worker
 * under a slightly different URL on the same scope, and registering
 * unconditionally makes the two overwrite each other on every page load.
 *
 * Removing this call is not an option: the SDK only installs the worker once
 * notification permission is granted, and Chrome needs a registered worker with
 * a fetch handler to offer the PWA install prompt.
 */
export const registerServiceWorker = async (): Promise<void> => {
  if (!('serviceWorker' in navigator)) return

  try {
    if (await navigator.serviceWorker.getRegistration('/')) return

    // Docroot copy of themes/custom/lhc/public/OneSignalSDKWorker.js (npm run sw:copy)
    await navigator.serviceWorker.register('/OneSignalSDKWorker.js', { scope: '/' })
  } catch (error) {
    console.error('Service worker registration failed:', error)
  }
}
